// extracted by mini-css-extract-plugin
export var phone = "_21-0";
export var phoneDragging = "_21-1";